import { showCheckout } from './checkout';
import { productLoadIntoList } from './products';
import { showStart } from './start';

export function hideAllInMain() {
  const parent = document.getElementById('main-content-wrapper');
  const children = parent.querySelectorAll('*');
  children.forEach(child => {
    child.classList.remove('visible');
  });
}

export function manageErrorBox(title, text) {
  document.getElementById('error-popup-container').classList.add('visible');
  const errorTitle = document.getElementById('error-title');
  const errorText = document.getElementById('error-text');
  errorTitle.textContent = title;
  errorText.textContent = text;
}

export function manageSuccessBox(title, text, spinner = false) {
  document.getElementById('success-popup-container').classList.add('visible');
  document.getElementById('success-continue-button__spinner').classList.add('hidden');
  document.getElementById('success-continue-button').disabled = false;
  document.getElementById('success-continue-button').classList.remove('disabled');
  document.getElementById('success-continue-button__text').classList.remove('hidden');
  const errorTitle = document.getElementById('success-title');
  const errorText = document.getElementById('success-text');
  errorTitle.textContent = title;
  errorText.textContent = text;

  if (spinner) {
    document.getElementById('success-continue-button__spinner').classList.remove('hidden');
    document.getElementById('success-continue-button').classList.add('disabled');
    document.getElementById('success-continue-button').disabled = true;
    document.getElementById('success-continue-button__text').classList.add('hidden');
  }
}

export function stopSpinnerSucessBox(title, text) {
  document.getElementById('success-continue-button__spinner').classList.add('hidden');
  document.getElementById('success-continue-button').disabled = false;
  document.getElementById('success-continue-button').classList.remove('disabled');
  document.getElementById('success-continue-button__text').classList.remove('hidden');
  const errorTitle = document.getElementById('success-title');
  const errorText = document.getElementById('success-text');
  errorTitle.textContent = title;
  errorText.textContent = text;
}

export function loadStart() {
  showStart();
}

export function loadProductList() {
  const productList = document.getElementById('product-list');
  while (productList.firstChild) {
    productList.removeChild(productList.lastChild);
  }

  productLoadIntoList(null);
}

export function showBackButton() {
  const backElement = document.querySelector('#back-button-container');
  backElement.classList.add('visible');

  if (document.querySelector('#product-list-container').classList.contains('visible')) {
    backElement.style.bottom = '82px';
  } else {
    backElement.style.bottom = '10px';
  }
}

export function hideBackButton() {
  const backElement = document.querySelector('#back-button-container');
  backElement.classList.remove('visible');
}

export function showContinueShopping() {
  const continueShopping = document.querySelector('#contiune-shopping');
  continueShopping.classList.add('visible');

  if (document.querySelector('#product-list-container').classList.contains('visible')) {
    continueShopping.style.bottom = '82px';
  } else {
    continueShopping.style.bottom = '10px';
  }
}

document.getElementById('product-list-container').classList.add('visible');
document.getElementById('search-container').classList.add('visible');
document.getElementById('product-loading').classList.add('visible');

const errorContinueButton = document.getElementById('error-continue-button');
errorContinueButton.addEventListener('click', function() {
  document.getElementById('error-popup-container').classList.remove('visible');
  if (window.location.search && window.location.search.indexOf('?swish=done&requestid=') > -1) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('status');
    urlParams.delete('swish');
    window.location.search = urlParams.toString();
  }
  const purchaseButton = document.getElementById('purchase-button');
  purchaseButton.disabled = false;
  purchaseButton.textContent = 'Slutför';
});

const successContinueButton = document.getElementById('success-continue-button');
successContinueButton.addEventListener('click', function() {
  document.getElementById('success-popup-container').classList.remove('visible');
  hideAllInMain();
  loadStart();
});

const cartButtonToCheckout = document.getElementById('cart-go-to-checkout');
cartButtonToCheckout.addEventListener('click', function() {
  hideAllInMain();
  showCheckout();
  // showBackButton();
});

const backElement = document.querySelector('#back-button-container');
backElement.addEventListener('click', function() {
  hideAllInMain();
  loadStart();
});

const logoElement = document.querySelector('.logo');
logoElement.addEventListener('click', function() {
  hideAllInMain();
  loadStart();
});

const continueShoppingButton = document.querySelector('#continue-shopping');
continueShoppingButton.addEventListener('click', function() {
  hideAllInMain();
  loadStart();
  hideBackButton();
});

const clearSearchButton = document.querySelector('#wl-clear-search');
const searchInputField = document.querySelector('#default-search');
clearSearchButton.style.display = 'none';
searchInputField.addEventListener('keyup', function() {
  // console.log(searchInputField.value);
  if (searchInputField.value.length > 0) {
    clearSearchButton.style.display = 'block';
  } else {
    clearSearchButton.style.display = 'none';
  }
});
clearSearchButton.addEventListener('click', function() {
  searchInputField.value = '';
  clearSearchButton.style.display = 'none';
});

export function prodlistInputQtyPrices() {
  const prodlistInput = document.querySelectorAll('#product-list div.amount-wrapper input');
  const sessionProdlist = JSON.parse(sessionStorage.getItem('product_list'));
  if (prodlistInput) {
    prodlistInput.forEach(element1 => {
      element1.addEventListener('change', function() {
        const sessionProdlistItem = sessionProdlist.find(obj => obj.Itemcode === JSON.parse(element1.closest('div.grid').querySelector('input[type="hidden"]').value).item);
        let originalPrice = true;

        if (sessionProdlistItem?.QtyPrices) {
          if (!Array.isArray(sessionProdlistItem.QtyPrices.QtyPrice)) {
            sessionProdlistItem.QtyPrices.QtyPrice = [sessionProdlistItem.QtyPrices.QtyPrice];
          }
        }

        sessionProdlistItem?.QtyPrices?.QtyPrice.forEach(element => {
          if (parseFloat(element1.value) >= parseFloat(element.Qty)) {
            element1.closest('div.grid').querySelector('p').textContent = `${element.Price} kr`;
            originalPrice = false;
          }
        });

        if (originalPrice) {
          element1.closest('div.grid').querySelector('p').textContent = `${sessionProdlistItem.Price} kr`;
        }
      });
    });
  }
}
